import React from 'react';

import SnackbarMessage from './message';

const showSnackbar = ({ message, withButton, variant, enqueueSnackbar }) => {
  const text = message || 'Não conseguimos acessar o servidor.';
  enqueueSnackbar(text, {
    content: (key, msg) => (
      <SnackbarMessage
        open
        id={key}
        message={msg}
        variant={variant}
        withButton={withButton}
      />
    )
  });
};

export default showSnackbar;
